module.exports = __webpack_public_path__ + "img/menuicon-107-active.e913080c.png";